import { Button } from 'foundations-components/transitional/components/Button';
import { H4 } from 'foundations-components/transitional/components/H4';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useShepherdDismissState } from '../../../compose/protected/hooks';
import { View } from 'foundations-components/components/View';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ATTRIBUTE_STORAGE_KEY = `composer:inbox-dismissed-wa-banner-shepherd`;
export function WABannerShepherd({
  children
}) {
  const {
    isDismissed,
    setDismissed
  } = useShepherdDismissState({
    attributeKey: ATTRIBUTE_STORAGE_KEY
  });
  return /*#__PURE__*/_jsx(Popover, {
    use: "shepherd",
    inlineSize: "400px",
    open: !isDismissed,
    showCloseButton: true,
    onOpenChange: setDismissed,
    placement: "left",
    closeOnOutsideClick: false,
    autoPlacement: false,
    content: {
      header: /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.whatsapp.bannerShepherd.title"
        })
      }),
      body: /*#__PURE__*/_jsx(View, {
        textAlign: "left",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.whatsapp.bannerShepherd.body"
        })
      }),
      footer: /*#__PURE__*/_jsx(View, {
        textAlign: "left",
        children: /*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: setDismissed,
          size: "small",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "composer-ui.whatsapp.bannerShepherd.confirmButton"
          })
        })
      })
    },
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: children
    })
  });
}
WABannerShepherd.displayName = 'WABannerShepherd';